import api from "@/aygulyazilim/libs/axios"
import { getI18n } from "@/plugins/i18n"
import moment from "moment"
import { defineStore } from "pinia"
import { toast } from "vue3-toastify"
import "vue3-toastify/dist/index.css"

import { useAuthStore } from "./useAuth"

const secretKeyBase = import.meta.env.VITE_APP_secretKey
const version = import.meta.env.VITE_APP_VERSION

export const useHelpersStore = defineStore("helpers", {
  state: () => {
    const t = getI18n().global.t

    return {
      formatTarih: date => {
        const day = date.getDate()
        const month = date.getMonth() + 1
        const year = date.getFullYear()

        return `${day}.${month}.${year}`
      },
      message: null,
      errors: {},
      version: version,
      config: {
        firma_adi: "",
      },
      ilList: [],
      items: [],
      activeOptions: [
        { label: t("activeOptions.Hepsi"), value: -1 },
        { label: t("activeOptions.Aktif"), value: 1 },
        { label: t("activeOptions.Pasif"), value: 0 },
      ],
      projeFaturaTipList: [
        { label: t("projeFaturaTipList.Kısmı"), value: 0 },
        { label: t("projeFaturaTipList.Tam"), value: 1 },
      ],
      musteriTip: [
        { label: t("musteriTip.Alış-Satış"), value: 0 },
        { label: t("musteriTip.Alış"), value: 1 },
        { label: t("musteriTip.Satış"), value: 2 },
      ],
      paraTur: [
        { label: t("paraTur.TL"), value: 1 },
        { label: t("paraTur.Euro"), value: 2 },
        { label: t("paraTur.Dolar"), value: 3 },
      ],
      projeHourTypesList: [
        { label: t("projeHourTypesList.Seçiniz"), value: 0 },
        { label: t("projeHourTypesList.General hours"), value: 1 },
        { label: t("projeHourTypesList.AI-IS AI Models"), value: 2 },
        { label: t("projeHourTypesList.AI-IS MM support"), value: 3 },
        { label: t("projeHourTypesList.AI-IS Commercial"), value: 4 },
        { label: t("projeHourTypesList.AI-IS Non-commercial"), value: 5 },
        { label: t("projeHourTypesList.Bee4GIS Commercial"), value: 6 },
        { label: t("projeHourTypesList.Bee4GIS Non-commercial"), value: 7 },
      ],
      projeAltStatusList: [
        { label: t("projeAltStatusList.Bekliyor"), value: 1 },
        { label: t("projeAltStatusList.İşlemde"), value: 3 },
        { label: t("projeAltStatusList.Bitti"), value: 4 },
      ],
      projeAltStatusAdminList: [
        { label: t("projeAltStatusAdminList.Bekliyor"), value: 1 },
        { label: t("projeAltStatusAdminList.İşlemde"), value: 3 },
        { label: t("projeAltStatusAdminList.Bitti"), value: 4 },
        { label: t("projeAltStatusAdminList.Gönderildi"), value: 5 },
        { label: t("projeAltStatusAdminList.Onay"), value: 6 },
        { label: t("projeAltStatusAdminList.Kapalı"), value: 9 },
      ],
      projeAltUcretTurList: [
        { label: t("projeAltUcretTurList.Seçiniz"), value: 0 },
        { label: t("projeAltUcretTurList.Saat Fiyat"), value: 2 },
        { label: t("projeAltUcretTurList.Sabit Fiyat"), value: 3 },
        { label: t("projeAltUcretTurList.KM Fiyat"), value: 1 },
        { label: t("projeAltUcretTurList.Adet Fiyat"), value: 4 },
      ],

      // kontrol et
      medenidurumListe: [
        { label: t("medenidurumListe.Bilinmiyor"), value: "Bilinmiyor" },
        { label: t("medenidurumListe.Bekar"), value: "Bekar" },
        { label: t("medenidurumListe.Evli"), value: "Evli" },
        { label: t("medenidurumListe.Boşanmış"), value: "Boşanmış" },
        { label: t("medenidurumListe.Dul"), value: "Dul" },
      ],

      // kontrol et
      ogrenimListe: [
        { label: t("ogrenimListe.Bilinmiyor"), value: "Bilinmiyor" },
        { label: t("ogrenimListe.İlköğretim"), value: "İlköğretim" },
        { label: t("ogrenimListe.Ortaöğretim"), value: "Ortaöğretim" },
        { label: t("ogrenimListe.Lise"), value: "Lise" },
        { label: t("ogrenimListe.ÖnLisans"), value: "ÖnLisans" },
        { label: t("ogrenimListe.Lisans"), value: "Lisans" },
        { label: t("ogrenimListe.Yüksek Lisans"), value: "Yüksek Lisans" },
        { label: t("ogrenimListe.Doktora"), value: "Doktora" },
      ],

      // kontrol et
      kangrubuListe: [
        { label: t("kangrubuListe.Bilinmiyor"), value: "Bilinmiyor" },
        { label: t("kangrubuListe.A+"), value: "A+" },
        { label: t("kangrubuListe.A-"), value: "A-" },
        { label: t("kangrubuListe.B+"), value: "B+" },
        { label: t("kangrubuListe.B-"), value: "B-" },
        { label: t("kangrubuListe.AB+"), value: "AB+" },
        { label: t("kangrubuListe.AB-"), value: "AB-" },
        { label: t("kangrubuListe.0+"), value: "0+" },
        { label: t("kangrubuListe.0-"), value: "0-" },
      ],

      // kontrol et
      cinsiyetListe: [
        { label: t("cinsiyetListe.Bilinmiyor"), value: "Bilinmiyor" },
        { label: t("cinsiyetListe.Erkek"), value: "Erkek" },
        { label: t("cinsiyetListe.Kadın"), value: "Kadın" },
      ],

      // kontrol et 
      egitimTurList: [
        { value: "Diploma", label: t("egitimTurList.Diploma") },
        { value: "Sertifika", label: t("egitimTurList.Sertifika") },
        { value: "Belge", label: t("egitimTurList.Belge") },
        { value: "Öğrenci", label: t("egitimTurList.Öğrenci") },
      ],
      izinTurList: [
        { value: 1, label: t("izinTurList.Yıllık ücretli izin") },
        { value: 2, label: t("izinTurList.Ücretsiz izin") },
        { value: 3, label: t("izinTurList.Mazeret izni") },
        { value: 4, label: t("izinTurList.Diğer izinler") },
        { value: 5, label: t("izinTurList.Rapor") },
      ],
      izinTurGetList: [
        { value: 0, label: t("izinTurGetList.Yıllık ücretli girişi") },
        { value: 1, label: t("izinTurGetList.Yıllık ücretli izin") },
        { value: 2, label: t("izinTurGetList.Ücretsiz izin") },
        { value: 3, label: t("izinTurGetList.Mazeret izni") },
        { value: 4, label: t("izinTurGetList.Diğer izinler") },
        { value: 5, label: t("izinTurGetList.Rapor") },
      ],

      // kontrol et
      envanterStatusList: [
        { label: t("envanterStatusList.Yeni"), value: "Yeni" },
        { label: t("envanterStatusList.Aktif"), value: "Aktif" },
        { label: t("envanterStatusList.Zimmet"), value: "Zimmet" },
        { label: t("envanterStatusList.Tamirde"), value: "Tamirde" },
        { label: t("envanterStatusList.Depoda"), value: "Depoda" },
        { label: t("envanterStatusList.Demirbaş"), value: "Demirbaş" },
        { label: t("envanterStatusList.Kayıp"), value: "Kayıp" },
        { label: t("envanterStatusList.Pasif"), value: "Pasif" },
        { label: t("envanterStatusList.Satıldı"), value: "Satıldı" },
        { label: t("envanterStatusList.Hurda"), value: "Hurda" },
        { label: t("envanterStatusList.Diğer"), value: "Diğer" },
      ],
      yemekKartiTipi: [
        { label: t("yemekKartiTipi.Yok"), value: 0 }, 
        { label: t("yemekKartiTipi.Mobil"), value: 1 },
        { label: t("yemekKartiTipi.Fiziksel"), value: 2 },
      ],
      menus: [],
      shortcuts: [],
      licenses: [],
      allModules: [],
    }
  },
  getters: {
    activeOptionsTranslated: state => {
      const t = getI18n().global.t

      return state.activeOptions.map(opt => ({
        ...opt,
        label: t(opt.label),
      }))
    },
    resolveActiveVariant: state => {
      const t = getI18n().global.t

      return active => {
        if (active === 1) return { color: "primary", text: t("Aktif") }
        if (active === true) return { color: "primary", text: t("Aktif") }
        else return { color: "error", text: t("Pasif") }
      }
    },
    resolveEvetVariant: state => {
      const t = getI18n().global.t

      return active => {
        if (active === 1) return { color: "primary", text: t("Evet") }
        if (active === true) return { color: "primary", text: t("Evet") }
        else return { color: "error", text: t("Hayır") }
      }
    },
    getDeger: state => {
      return (value, tip = 0) => {
        const item = state.items.find(item => item.name === value)
        if (tip == 1) return item?.deger == 1 ? true : false

        return item ? item.deger : ""
      }
    },
    getMusteriTip: state => {
      return value => {
        const item = state.musteriTip.find(item => item.value === value)

        return item ? item.label : ""
      }
    },
    getParaTur: state => {
      return value => {
        const item = state.paraTur.find(item => item.value === value)

        return item ? item.label : ""
      }
    },

    getProjeHourTypesList: state => {
      return value => {
        const item = state.projeHourTypesList.find(
          item => item.value === value,
        )


        return item ? item.label : ""
      }
    },
    getProjeHourTypesListRapor: state => {
      return value => {
        if (value == "0") return "General hours"

        const item = state.projeHourTypesList.find(
          item => item.value === value,
        )


        return item ? item.label : "General hours"
      }
    },
    getProjeHourTypesListRaporRpt: state => {
      return value => {
        if (value == "0") return "Contract hours"

        const item = state.projeHourTypesList.find(
          item => item.value === value,
        )


        return item ? item.label : "Contract hours"
      }
    },
    getProjeAltStatusAdminList: state => {
      return value => {
        const item = state.projeAltStatusAdminList.find(
          item => item.value === value,
        )


        return item ? item.label : ""
      }
    },

    getIzinTurList: state => {
      return value => {
        const item = state.izinTurGetList.find(item => item.value === value)

        return item ? item.label : ""
      }
    },
    getProjeAltUcretTur: state => {
      return value => {
        const item = state.projeAltUcretTurList.find(item => item.value === value)

        return item ? item.label : ""
      }
    },

    // yetkiKontrol() {
    //   return ({ k = [], a = false, p = false }) => {
    //     if ((k.length == 0) & (a == false) & (p == false)) return true;
    //     if (p && useAuthStore().user.programci) return true;
    //     if (a && (useAuthStore().user.programci || useAuthStore().user.admin))
    //       return true;
    //     if (k.length == 0) return true;
    //     for (let i = 0; i < k.length; i++) {
    //       if (useAuthStore().user.programci || useAuthStore().user.admin)
    //         return true;
    //       const s = useAuthStore().user.yetkiler.filter((x) => x.kod === k[i]);
    //       if (s.length > 0) return true;
    //     }
    //
    //     return false;
    //   };
    // },
  },
  actions: {
    processMenuItems(items) {
      return items.map(item => {
        const newItem = { ...item }

        // Ensure yetki object exists and is deep-cloned to avoid mutating shared objects
        if (!newItem.yetki) {
          newItem.yetki = { k: [] }
        } else {
          newItem.yetki = {
            ...newItem.yetki,
            k: newItem.yetki.k ? [...newItem.yetki.k] : [],
          }
        }

        if (newItem.children) {
          if (newItem.children.length === 0) {
            delete newItem.children
          } else {
            newItem.children = this.processMenuItems(newItem.children)

            // Aggregate children's permissions (yetki.k) into parent
            newItem.children.forEach(child => {
              if (child.yetki && child.yetki.k) {
                child.yetki.k.forEach(code => {
                  if (!newItem.yetki.k.includes(code)) {
                    newItem.yetki.k.push(code)
                  }
                })
              }
            })
          }
        }

        return newItem
      })
    },

    setMenus(menusData) {
      if (Array.isArray(menusData)) {
        this.menus = this.processMenuItems(menusData)
      }
    },

    async fetchMenu(force = false) {
      if (!force && this.menus.length > 0) {
        return
      }

      try {
        // Paralel olarak licenses, menu ve shortcuts isteklerini çalıştır
        const [licensesRes, menuRes] = await Promise.all([
          this.licenses.length === 0 ? api.get("menu/licenses") : Promise.resolve(null),
          api.get("menu"),
          this.fetchShortcuts(),
        ])

        if (licensesRes && licensesRes.data) {
          this.licenses = licensesRes.data.aktif || []
          this.allModules = licensesRes.data.tum || []
        }

        if (menuRes && menuRes.data) {
          this.setMenus(menuRes.data)
        }
      } catch (error) {
        console.error("Error fetching menu:", error)
      }
    },
    async fetchLicenses(force = false) {
      if (!force && this.licenses.length > 0) {
        return
      }

      try {
        const res = await api.get("menu/licenses")
        if (res && res.data) {
          this.licenses = res.data.aktif || []
          this.allModules = res.data.tum || []
        }
      } catch (error) {
        console.error("Error fetching licenses:", error)
      }
    },
    navMenu() {
      const filterMenu = items => {
        const result = []
        for (let i = 0; i < items.length; i++) {
          const item = items[i]
          const hasAccess = item.yetki === undefined || item.yetki === null || this.yetkiKontrol(item.yetki)
          
          if (hasAccess) {
            const newItem = { ...item }
            if (newItem.children && newItem.children.length > 0) {
              newItem.children = filterMenu(newItem.children)
            }
            result.push(newItem)
          }
        }
        
        return result
      }

      return filterMenu(this.menus)
    },
    yetkiKontrol({ k = [], a = false, p = false, m = null } = {}) {
      const authStore = useAuthStore()
      const user = authStore?.user

      if (!user) return false

      // License check if module (m) is specified
      // Only check if it's one of the licenseable modules
      if (m && this.allModules.includes(m) && !this.licenses.includes(m)) return false

      // Programcı zorunlu ise ve kullanıcı programcı değilse doğrudan engelle
      if (p && !user.programci) return false

      // Admin zorunlu ise ve kullanıcı admin veya programcı değilse doğrudan engelle
      if (a && !(user.admin || user.programci)) return false

      if (k.length === 0 && a === false && p === false) return true
      if (user.programci || user.admin) return true

      const normalizedK = []
      for (const item of k) {
        if (typeof item === 'string' && item.includes(',')) {
          normalizedK.push(...item.split(',').map(s => s.trim()))
        } else {
          normalizedK.push(item)
        }
      }

      for (let i = 0; i < normalizedK.length; i++) {
        const arananKod = String(normalizedK[i])
        const s = user.yetkiler?.filter(x => String(x.kod) === arananKod)
        if (s && s.length > 0) return true
      }

      return false
    },
    async fetchConfig() {
      try {
        this.items = []

        const res = await api.get("config")
        if (res != undefined) {
          this.items = res?.data
          for (let i = 0; i < this.items.length; i++) {
            this.config[this.items[i].name] = this.getDeger(this.items[i].name, this.items[i].tip)
          }

          // this.config.varsayilan_il = this.getDeger("varsayilan_il");
          // this.config.resim_upload_max = this.getDeger("resim_upload_max");
          // this.config.video_upload_max = this.getDeger("video_upload_max");
          // this.config.nakitbilgi = this.getDeger("nakitbilgi");
          // this.config.whatsapp_link = this.getDeger("whatsapp_link");
          // this.config.havalebilgi = this.getDeger("havalebilgi");
          // this.config.gizlilik_politikasi = this.getDeger(
          //   "gizlilik_politikasi"
          // );
        }
      } catch (error) {
        console.error("Error loading config:", error)
      }
    },
    async toast(status, message) {
      switch (status) {
      case "success":
        toast.success(message, {
          theme: "auto",
          autoClose: 5000,
          dangerouslyHTMLString: true,
        })
        break
      case "error":
        toast.error(message, {
          theme: "auto",
          autoClose: 5000,
          dangerouslyHTMLString: true,
        })
        break
      case "danger":
      case "warn":
      case "warning":
        toast.warning(message, {
          theme: "auto",
          autoClose: 5000,
          dangerouslyHTMLString: true,
        })
        break
      case "info":
        toast.info(message, {
          theme: "auto",
          autoClose: 5000,
          dangerouslyHTMLString: true,
        })
        break
      default:
        toast(message, {
          theme: "auto",
          type: "default",
          autoClose: 5000,
          dangerouslyHTMLString: true,
        })
      }
    },
    async listIl() {
      const res = await api.get("il")
      if (res != undefined) {
        this.ilList = res?.data || []
      }
    },
    async copyHafiza(mytext) {
      try {
        await navigator.clipboard.writeText(mytext)
        alert("Copied")
      } catch ($e) {
        alert("Cannot copy")
      }
    },
    encryptData(data) {
      const tarih = moment().format("YYYYMMDD")
      const secretKey = `${secretKeyBase}${tarih}`
      const dataString = JSON.stringify(data)

      // Veriyi şifreleyin
      return CryptoJS.AES.encrypt(
        dataString,
        secretKey,
      ).toString()
    },
    async downloadFile(blob, fileName) {
      if (window.showSaveFilePicker) {
        try {
          const handle = await window.showSaveFilePicker({
            suggestedName: fileName,
            types: [{
              description: 'Excel Dosyası',
              accept: { 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'] },
            }],
          })

          const writable = await handle.createWritable()

          await writable.write(blob)
          await writable.close()

          return
        } catch (err) {
          console.warn("SaveFilePicker cancelled or failed, falling back:", err)

          // Kullanici iptal ettiyse veya hata aldiksa fallback'e devam et
          if (err.name === 'AbortError') return
        }
      }

      // 2. IE11 ve Eski Edge
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName)

        return
      }

      // 3. Diger Tarayicilar (Firefox, Safari vb.) - Data URI Fallback
      const reader = new FileReader()

      reader.onload = function () {
        const url = reader.result
        const a = document.createElement('a')

        a.style.display = 'none'
        a.href = url
        a.setAttribute("download", fileName)
        a.download = fileName

        document.body.appendChild(a)
        a.click()

        setTimeout(() => {
          document.body.removeChild(a)
        }, 100)
      }
      reader.readAsDataURL(blob)
    },

    // Shortcuts Actions
    async fetchShortcuts() {
      try {
        const res = await api.get("shortcuts")
        if (res && res.data) {
          this.shortcuts = res.data
        }
      } catch (error) {
        console.error("Error fetching shortcuts:", error)
      }
    },
    async addShortcut(payload) {
      try {
        const res = await api.post("shortcuts", payload)
        if (res && res.data) {
          this.shortcuts.push(res.data)
          this.toast("success", "Kısayol eklendi")
        }
      } catch (error) {
        if (error.response && error.response.status === 409) {
          this.toast("warning", "Bu kısayol zaten ekli")
        } else {
          this.toast("error", "Kısayol eklenirken hata oluştu")
          console.error(error)
        }
      }
    },
    async removeShortcut(uuid) {
      try {
        await api.delete(`shortcuts/${uuid}`)
        this.shortcuts = this.shortcuts.filter(s => s.uuid !== uuid)
        this.toast("info", "Kısayol silindi")
      } catch (error) {
        this.toast("error", "Silme işlemi başarısız")
        console.error(error)
      }
    },
  },
})
